import { FileDataTypes } from "WidgetProvider/constants";

export default FileDataTypes;
